import { render, staticRenderFns } from "./NewCustomers.vue?vue&type=template&id=02935c6e"
import script from "./NewCustomers.vue?vue&type=script&lang=js"
export * from "./NewCustomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports